// extracted by mini-css-extract-plugin
export default {"news_container":"News_news_container__3tuDF","card_container":"News_card_container__ftD2d"};